import { useI18n } from "../../i18n";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faUser } from "@fortawesome/free-solid-svg-icons";
import PortfolioModal from "./portfolioModal";
import { preloadPortfolioImage } from "./preloadPortfolioImage";
import styles from "./styles/portfolioCard.module.css";
import projectStyles from "./styles/project.module.css";
import entryStyles from "./styles/entry.module.css";
import homeStyles from "./styles/experience.module.css";
import { Description, Stacks } from "./portfolioContent";

export default function PortfolioCard({ item, variant = "list" }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const compact = variant === "compact";
  const project = Boolean(item.type);
  const skin = compact
    ? project
      ? projectStyles.project
      : homeStyles["homepage-experience"]
    : entryStyles.experience;
  return (
    <>
      <article className={`${styles.card} ${skin}`}>
        {compact ? (
          project ? (
            <div className={projectStyles["project-container"]}>
              <div className={projectStyles["project-icon"]}>
                <FontAwesomeIcon
                  icon={item.type === "work" ? faBriefcase : faUser}
                />
              </div>
              <div className={projectStyles["project-title"]}>{item.title}</div>
              <div className={projectStyles["project-description"]}>
                {item.summary}
              </div>
              <Stacks stacks={item.stacks} />
            </div>
          ) : (
            <div className={homeStyles["homepage-experience-content"]}>
              <div className={homeStyles["homepage-experience-header"]}>
                <div className={homeStyles["homepage-experience-date"]}>
                  |&nbsp;&nbsp;&nbsp;{item.date}
                </div>
                <div className={homeStyles["homepage-experience-label"]}>
                  {t(item.label)}
                </div>
              </div>
              <div className={homeStyles["homepage-experience-title"]}>
                {item.title}
              </div>
              <div className={homeStyles["homepage-experience-description"]}>
                {item.description}
              </div>
            </div>
          )
        ) : (
          <>
            <div className={entryStyles["experience-left-side"]}>
              <div className={entryStyles["experience-date"]}>{item.date}</div>
            </div>
            <div className={entryStyles["experience-right-side"]}>
              <div className={entryStyles["experience-title"]}>
                {item.title}
              </div>
              <div className={entryStyles["experience-description"]}>
                <Description item={item} />
              </div>
              <Stacks stacks={item.stacks} />
            </div>
          </>
        )}
        <button
          type="button"
          className={styles.trigger}
          aria-label={t("details", { title: item.title })}
          aria-haspopup="dialog"
          onPointerEnter={() => preloadPortfolioImage(item.images[0]?.src)}
          onFocus={() => preloadPortfolioImage(item.images[0]?.src)}
          onPointerDown={() => preloadPortfolioImage(item.images[0]?.src)}
          onClick={() => setOpen(true)}
        />
      </article>
      {open && <PortfolioModal item={item} onClose={() => setOpen(false)} />}
    </>
  );
}
